import React, {FunctionComponent} from "react";
import {FilePreviewerProps} from "../FilePreview";

export const OtherFilePreview: FunctionComponent<FilePreviewerProps> = (props) => {
    return (
        <p className='bold-text'>{props.file?.display_name}{props.file?.extension}</p>
    );
};